
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply/steps",
      function () {
        return require("private-next-pages/apply/steps.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply/steps"])
      });
    }
  